import { useLayoutEffect, useState } from "react";
import { restore, type Session } from "./lib/auth";
import { SignIn } from "./SignIn";
import { MailApp } from "./MailApp";

export function App() {
  const [session, setSession] = useState<Session | null>(() => restore());

  // The sign-in screen and the app have different page-level styling (the
  // design centres the auth card on the body), so the body class follows the
  // route rather than both stylesheets fighting over `body`. Layout effect, not
  // render: every rule in signin.css is scoped to `body.signin`, so applying it
  // after paint would flash the auth card unstyled.
  useLayoutEffect(() => {
    document.body.classList.toggle("signin", !session);
  }, [session]);

  return session ? (
    <MailApp session={session} onSignOut={() => setSession(null)} />
  ) : (
    <SignIn onSignedIn={setSession} />
  );
}
